import styled from 'styled-components';

export default styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  border: 1px solid #404040;
  border-radius: 5px;
  background-color: ${props => (props.checked ? '#0078ff' : 'transparent')};
  border-color: ${props => (props.checked ? '#0078ff' : '#404040')};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 4px 5px;

  svg {
    width: 12px;
    height: 8.916px;
    stroke: #ffffff;
    stroke-width: 2;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  &:hover {
    border-color: ${props => (props.checked ? '#0078ff' : '#606060')};
  }
`;
